
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import iphone from '../../assets/img/iphone.png';
import match from '../../assets/img/match.png';
import chat from '../../assets/img/chat.png';
import like from '../../assets/img/like.png';
import map from '../../assets/img/mapa.png';
import midias from '../../assets/img/Social Media.svg';
import icon from '../../assets/img/icon.svg';
import peaple from '../../assets/img/peaple.svg';
import emoji from '../../assets/img/friendships.svg';
import vector1 from '../../assets/img/vector1dsk.svg';
import vector2 from '../../assets/img/Vector2.png';
import vector3 from '../../assets/img/Vector3.png';
import vector4 from '../../assets/img/Vector4.png';
import vector5 from '../../assets/img/Vector5.png';
import vector6 from '../../assets/img/Vector6.png';
import google from '../../assets/img/boton google play.svg';
import apple from '../../assets/img/boton app store.svg';
import ny from '../../assets/img/nyc.svg';
import arrow from '../../assets/img/arrow.svg';
import estilo from '../../assets/img/background-vector.png';
import background from '../../assets/img/backgroundvector.svg'; // Caminho para a imagem
import { GiBrazilFlag } from "react-icons/gi"; 


const Home = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
    <>
    <header className="header-containerx">
        
            <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
                <a href="/br">Home</a>
                <a href="/embaixadores">Embaixadores</a>
                <a href="/timesobr">Time Sobr</a>
                <a href="/termosepolitica">Termos e Políticas</a>
            </nav>
            <div className="header-right">
            <a className='butontranslate' href="/">en-US</a>
            <a className='butontranslate' href="/es">es-ES</a>
            </div>
        </header>
        <body>
            <div className='div1'>
                <div className="iphone5">
                    <main>
                    <section className="hero2">
                            <h1>Conecte-se com pessoas que estão revolucionando a felicidade!</h1>
                            <p>Sobr é mais do que um aplicativo - é um ponto de encontro para aqueles que escolheram um estilo de vida sóbrio, repleto de saúde e diversão.
                            </p>                   
                        <br></br>
                        <br></br>
                        <button className="demo-button">BAIXE AGORA</button>
                    </section>
                    </main>
                    <img src={iphone} alt="iphone" title="iphone" height="500" />
                    
                </div>                
                </div>
                <div className="content2dsk">
                    <img className='match2' src={match} alt="match" title="match" height="500" />  
                    <section>       
                            <h1>Conexões autênticas</h1>          
                            <p>Nosso algoritmo de matchmaking personalizado vai além do superficial. Analisamos seus interesses, preferências e comportamentos para sugerir perfis verdadeiramente compatíveis. Faça conexões significativas com pessoas que compartilham seus valores e estão comprometidas com a sobriedade.</p>                                    
                    </section>  
                </div>
                <div className="content3dsk">
                    <section>       
                            <h1>Converse com seus matches</h1>          
                            <p>Aqui, a comunicação é segura e privada. Use nosso recurso de bate-papo para se conectar com seus matches em tempo real. Compartilhe mensagens, fotos e momentos especiais, construindo laços genuínos e duradouros.</p>                                    
                    </section>  
                    <img className='chat' src={chat} alt="chat" title="chat" height="500" />  
                </div>
                <div className='div2'></div>
                <div className="content4dsk">
                    <img className='like2' src={like} alt="like" title="like" height="500" />  
                    <section>       
                            <h1>Mostre sua verdadeira essência</h1>          
                            <p>Seja você mesmo! Crie um perfil autêntico que reflita sua personalidade e interesses. Atraia matches ideais com base na sua autenticidade e compatibilidade, abrindo as portas para conexões reais e significativas.</p>                                    
                    </section>  
                </div>
                <div className='div3'></div>
                <div className="content5dsk">
                    <section className=' divnyc'>       
                            <h1>Descubra novos lugares</h1>          
                            <p>Explore o melhor da vida sóbria com o Sobr Places. Descubra eventos, atividades e locais perfeitos para socializar e conhecer novas pessoas em sua comunidade. Viva experiências autênticas e fortaleça seus laços na jornada para uma vida mais feliz e saudável.
Junte-se a nós na Sobr e descubra um mundo de possibilidades, onde a sobriedade é sinônimo de liberdade, alegria e conexão genuína.
</p>                                    
                    </section> 
                    
                    <div className='containerdsk'>
                    <img className="map" src={map} alt="map" title="map" height="500" />
                    </div> 
                </div>
                {/*<div className="content6dsk">
                    <h1>Sobr shouldn’t be somber.</h1>
                    <p>We created Sobr with the belief that being sober isn’t the end of the good times, but the start. Here’s our story in a few more words…</p>
                </div>
                <div className='carddsk'>
                <div className="support-carddsk">
                    <div className="peapledsk">
                        <img src={peaple} alt="members" title="members" />
                    </div>
                    <div className="textdsk">
                        <h2>+190.000</h2>
                        <p>members</p>
                    </div>
                </div>
                <div className="support-carddsk">
                    <div className="icondsk">
                        <img src={icon} alt="support" title="support" />
                    </div>
                    <div className="textdsk">
                        <h2>+3.3M</h2>
                        <p>Support Messages</p>
                    </div>
                </div>
                <div className="support-carddsk">
                    <div className="emojidsk">
                        <img src={emoji} alt="friendships" title="friendships" />
                    </div>
                    <div className="text">
                        <h2>+155,000</h2>
                        <p>friendships</p>
                    </div>
                </div>
                </div>
                <div className='downloaddsk'>
                    <h3> Download the app today! </h3>
                <img className="google3" src={google} alt="Google play" title="Google play" height="38" width="140" />
                </div>
                <div className='div4'>
                <div className="content7dsk">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div>
                </div> */}
                
                <footer>
                    <div className="footer-contentdsk">
                        <p>Termos de Serviço | Política de Privacidade</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc., Todos os Direitos Reservados   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Home;
